/** WC VIP popup activity window (fixed GMT-4, aligned with other WC promotion constants). */
export const WC_VIP_POPUP_START_MS = Date.parse('2026-06-01T00:00:00-04:00');
export const WC_VIP_POPUP_END_MS = Date.parse('2026-08-07T23:59:59-04:00');

export const VIP_POPUP_COOLDOWN_MS = 7 * 24 * 60 * 60 * 1000;

export const isWithinVipPopupWindow = (nowMs: number): boolean =>
	nowMs >= WC_VIP_POPUP_START_MS && nowMs <= WC_VIP_POPUP_END_MS;

/** @returns whether the modal should be eligible to open based on last-dismiss timestamp */
export const shouldShowVipPopupByCooldown = (
	lastDismissedAtMs: number | null,
	nowMs: number
): boolean => {
	if (lastDismissedAtMs === null || Number.isNaN(lastDismissedAtMs)) {
		return true;
	}
	return nowMs - lastDismissedAtMs >= VIP_POPUP_COOLDOWN_MS;
};
